import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FormRow } from './SendStepOne'

import FontNumber from '../common/FontNumber'

const Title = styled.div`
  margin-top: 30px;
  .name {
    font-size: 20px;
    color: #212833;
    font-weight: bold;
    margin-right: 10px;
  }
  .fullName {
    font-size: 16px;
    color: #48515d;
  }
`

const Row = styled(FormRow)`
  display: flex;
  border: none;
  font-size: 14px;
  padding-bottom: 0;
  margin-top: 5px;
  .title {
    width: 50px;
    color: #848e9c;
    margin-right: 10px;
  }
  .value {
    color: #212833;
    line-height: 30px;
    width: 390px;
    word-break: break-all;
  }
`

export default class StepTwo extends PureComponent {
  static propTypes = {
    to: PropTypes.string,
    from: PropTypes.string,
    amount: PropTypes.string,
    memo: PropTypes.string,
    asset: PropTypes.object,
    transferFee: PropTypes.number,
  }

  static defaultProps = {
    to: '',
    from: '',
    amount: '',
    memo: '',
    asset: {},
    transferFee: 0,
  }

  render() {
    const { asset, to, from, amount, memo, transferFee } = this.props
    return (
      <div>
        <Title>
          <span className="name">{asset.displayName}</span>
          <span className="fullName">{asset.name}</span>
        </Title>
        <Row>
          <div className="title">To:</div>
          <div className="value">{to}</div>
        </Row>
        <Row>
          <div className="title">From:</div>
          <div className="value">{from}</div>
        </Row>
        <Row>
          <div className="title">Amount:</div>
          <div className="value">
            <FontNumber value={amount} />
          </div>
        </Row>
        <Row>
          <div className="title">Memo:</div>
          <div className="value">{memo}</div>
        </Row>
        <Row>
          <div className="title">Fee:</div>
          <div className="value">
            <FontNumber value={transferFee} /> BNB
          </div>
        </Row>
      </div>
    )
  }
}
